/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { MimicLogo } from '@/components/MimicLogo';
import { MainLayoutSiderToggle } from '@/components/Siders/MainLayoutSiderToggle';

import './MobileNavBar.css';

export type MobileNavBarProps = {
  toggleSidebar: () => void;
};

export function MobileNavBar({ toggleSidebar }: MobileNavBarProps) {
  return (
    <div className="mobile-navbar">
      <MainLayoutSiderToggle toggleSidebar={toggleSidebar} />
      <MimicLogo width="6rem" height="2rem" />
    </div>
  );
}
